
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/skisteder-naer-deg",
      function () {
        return require("private-next-pages/skisteder-naer-deg.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/skisteder-naer-deg"])
      });
    }
  